export default "__VITE_PUBLIC_ASSET__69d52d66__"